import { Button, ModalProps } from "antd";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../../store/app";
import CommonModal from "../../../../components/Modals/CommonModal";
import { deleteCompanyData } from "../../../../store/CompanyManagementSlice";

interface DeleteModalProps extends ModalProps {
  title?: string;
  close: any;
  open: boolean;
  deleteValues: any;
  name?: string | number;
  getList: any;
  setPaginationData: any;
  savePayload: any;
}
const DeleteCompanyManagement: React.FC<DeleteModalProps> = ({
  title,
  close,
  open,
  deleteValues,
  name,
  getList,
  setPaginationData,
  savePayload,
}) => {
  const dispatch: AppDispatch = useDispatch();
  const [saving, setSaving] = useState<boolean>(false);
  const deleteProduct = () => {
    setSaving(true);
    const payload = {
      id: deleteValues?.main_id,
    };
    dispatch(deleteCompanyData(payload))
      .then(() => {
        close();
        setPaginationData({
          page_number: 1,
          page_size: 10,
        });
        const payload = {
          page_number: 1,
          page_size: 10,
        };
        getList(payload);
      })
      .catch((e) => {
        console.warn(e);
      })
      .finally(() => setSaving(false));
  };
  return deleteValues ? (
    <CommonModal
      className="deleteModal"
      title={`Delete ${name}: ${title}`}
      open={open ? true : false}
      onCancel={close}
      footer={[
        <Button key="2" htmlType="button" className="EditBtn" onClick={close}>
          Cancel
        </Button>,
        <Button
          key="1"
          type="primary"
          className="cancelBtn"
          loading={saving}
          onClick={deleteProduct}
        >
          Delete
        </Button>,
      ]}
    >
      <div className="deleteNote">
        Are you sure want to delete
        <br />
        <strong>
          {name && <span>{name}:</span>} {title}
        </strong>
        ?
      </div>
    </CommonModal>
  ) : (
    <></>
  );
};

export default DeleteCompanyManagement;
